export const API = {
  SERVER: 'https://webapi.singlecare.com',
  PRESCRIPTION_QUERY_URL:
    'https://webapi.singlecare.com/api/elasticsearch/queryOrdered?queryData.indexes=prescriptions&queryData.maxResults=5&queryData.query=',
  GOOGLE_GEO_URL: 'https://api.singlecare.com/google-map-geolocation',
  HOST: 'https://www1.singlecare.com',
  WHY_NOT_PRESCRIPTION_DISCOUNT:
    'https://www.singlecare.com/blog/why-not-eligible-prescription-discount/',
  QA_API_SERVER: 'https://prodapi.singlecare.com',
  BLOG_HOST: 'https://www.singlecare.com',
  // GO_SERVER: 'https://api2.singlecare.com',
  GAPP_CLIENT_ID:
    '1020389366484-91tp3vtkedfgj06etpt5jh3l80bc0k83.apps.googleusercontent.com',
  ALLOW_DRUG_INFO_V2: true,
  ALLOW_PRICE_HISTORY: true,
  TV_TENANT_ID: 190,
  DRUG_STRUCTURE_VERSION: 'v6',
  MOCK_LOYALTY_API: true,
  SEARCH_DRUG_VERSON: 'v2',
  ENABLE_TRUEPILL: false,
  ALLOW_CONDITIONS: true,
  ALLOW_GOOGLE_CAPTCHA: true,
  ALLOW_PRICE_ALERT: true,
  GENIUS_RX: 'https://singlecare.geniusrx.com/account/dashboard',
  LOGOUT_DOMAIN_URL: 'https://geniusrx-prod.us.auth0.com/v2/logout',
  LOGOUT_CLIENT_ID: 'l1MtVm5Z0RT7sHtSi97gMyK0E3tlwvQs',
  LOGOUT_REDIRECT_TO_URL: 'https://www.singlecare.com/api/user/logOut',
  GENIUS_AJAX_LOGOUT_URL: 'https://singlecare.geniusrx.com/logout',
  ALLOW_HOME_DELIVERY: false,
  ALLOW_CONTENT_FULL_DATA: true,
  ALLOW_NAVITUS: true,
  ALLOW_PHYSICAL_CARD: true,
  ALLOW_NEW_PARTNER: true,
  NEW_PARTNER_URL: 'https://partners.singlecare.com',
  ALLOW_EMBED_PRICE_CHART: true,
  ALLOW_DRUG_PAGE_ADS: true,
  ALLOW_ADS_SEO_NAMES: [
    'unithroid',
    'levoxyl',
    'synthroid',
    'tirosint',
    'benadryl-allergy',
    'tylenol',
    'flomax',
    'vitamin-k2',
    'tart-cherry-advanced',
    'colace',
    'tylenol-extra-strength',
    'aleve',
    'wellbutrin-sr',
    'lamictal'
  ],
  ALLOW_WHAT_IS_PAGE_ADS: true,
  ALLOW_DOSAGE_PAGE_ADS: true,
  ALLOW_CONDITIONS_TREATMENT_PAGE_ADS: true,
  ALLOW_CONDITIONS_ADD_ON_PAGE_ADS: true,
  ALLOW_DRUG_CLASSES_PAGE_ADS: true,
  ALLOW_CUSTOM_ADS: true,
  ONETRUST_DOMAIN_ID: '7bb77fc0-ce08-40d5-84ec-5b4e400a0530',
  ALLOW_ADDRESS_V3: true,
  ALLOW_TIMEOUT_ON_ADS_FOR_INTELLIMIZE: false
};
